import { useTheme } from "../ThemeContext";
import { useState, useEffect, useCallback } from "react";
import { fmt } from "../theme";
import { get, post, put, del } from "../api";
import { Card, EmptyState } from "../components/UI";
import ReajusteMassa from "../components/ReajusteMassa";

const uploadArquivo = async (file, tipo = "geral") => {
  const fd = new FormData();
  fd.append("arquivo", file);
  fd.append("tipo", tipo);
  const r = await fetch("https://mixupbr.com.br/api/upload/", { method: "POST", body: fd });
  return r.json();
};

const toArr = (d) => { if (Array.isArray(d)) return d; if (d && typeof d === "object" && d.id) return [d]; return []; };

/* Máscara de preço: digita "1290" → "12,90" */
const mascaraPreco = (v) => {
  const nums = String(v).replace(/\D/g, "");
  if (!nums) return "";
  const n = parseInt(nums, 10);
  return (n / 100).toFixed(2).replace(".", ",");
};
const desmascarar = (v) => String(v).replace(",", ".").replace(/[^\d.]/g, "");

/* Estilos base */
const _iS = { width:"100%", padding:"12px 14px", borderRadius:10, border:"1px solid #E5E7EB", background:"#F9FAFB", color:"#111", fontSize:14, fontFamily:"inherit", outline:"none" };
const _lS = { fontSize:12, fontWeight:600, color:"#6B7280", marginBottom:6, display:"block" };

function Field({ label, value, onChange, ph, type = "text", money = false }) {
  const handleChange = (e) => {
    if (money) { onChange(mascaraPreco(e.target.value.replace(/\D/g, ""))); }
    else onChange(e.target.value);
  };
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={_lS}>{label}</label>
      <input type={money ? "text" : type} inputMode={money ? "numeric" : undefined}
        placeholder={ph} value={value} onChange={handleChange} style={_iS} />
    </div>
  );
}

function SelectField({ label, value, onChange, options }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={_lS}>{label}</label>
      <select value={value} onChange={e => onChange(e.target.value)} style={_iS}>
        {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </div>
  );
}

/* Botões de ação da lista */
function AcoesBotoes({ onEditar, onExcluir, onCopiar, C }) {
  return (
    <div style={{ display:"flex", gap:6, marginTop:10 }}>
      <button onClick={onEditar}
        style={{ flex:1, padding:"7px 0", borderRadius:8, border:`1px solid ${C.border}`, background:"transparent", color:C.text, cursor:"pointer", fontSize:12, fontWeight:600 }}>
        ✏️ Editar
      </button>
      {onCopiar && (
        <button onClick={onCopiar}
          style={{ flex:1, padding:"7px 0", borderRadius:8, border:`1px solid ${C.border}`, background:"transparent", color:C.text, cursor:"pointer", fontSize:12, fontWeight:600 }}>
          📋 Copiar
        </button>
      )}
      <button onClick={onExcluir}
        style={{ flex:1, padding:"7px 0", borderRadius:8, border:"none", background:"#E8201A12", color:"#E8201A", cursor:"pointer", fontSize:12, fontWeight:700 }}>
        🗑 Excluir
      </button>
    </div>
  );
}

export default function Cadastro({ sub, lojaId }) {
  const { theme: C } = useTheme();
  const [categorias,    setCategorias]    = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [produtos,      setProdutos]      = useState([]);
  const [adicionais,    setAdicionais]    = useState([]);
  const [caixinhas,     setCaixinhas]     = useState([]);
  const [toast,         setToast]         = useState(null);

  /* Estados de edição */
  const [editCat,  setEditCat]  = useState(null);
  const [editSub,  setEditSub]  = useState(null);
  const [editProd, setEditProd] = useState(null);
  const [editAdi,  setEditAdi]  = useState(null);
  const [editCaixa,setEditCaixa]= useState(null);
  // Modal de Reajuste em Massa
  const [showReajuste, setShowReajuste] = useState(false);

  const [fCat,   setFCat]   = useState({ nome: "", descricao: "", ordem: "0" });
  const [fSub,   setFSub]   = useState({ nome: "", categoria_id: "", descricao: "" });
  const [fProd,  setFProd]  = useState({ nome: "", descricao: "", preco: "", preco_promocional: "", categoria_id: "", subcategoria_id: "", disponivel: "1", destaque: "0", ordem: "0", tempo_preparo: "15", cashback_pct: "0", imagem_url: "" });
  const [fAdi,   setFAdi]   = useState({ nome: "", preco: "", categoria_id: "", produto_id: "", grupo_nome: "", obrigatorio: "0", max_escolhas: "1", imagem_url: "" });
  const [fCaixa, setFCaixa] = useState({ nome: "", descricao: "", preco: "", preco_original: "", quantidade_limite: "", ativo: "1", imagem_url: "" });
  const [uploadingCaixa, setUploadingCaixa] = useState(false);
  const [uploadingProd,  setUploadingProd]  = useState(false);
  const [uploadingAdi,   setUploadingAdi]   = useState(false);

  /* Adicionais agora sao estruturados como GRUPOS (cada grupo tem N itens dentro)
     Formato: gruposDoForm = [{ id?, _key, nome, min_escolhas, max_escolhas, ordem, _novo?, _dirty?, itens:[{ id?, _key, nome, preco, imagem_url, ordem, _novo?, _dirty? }] }]
  */
  const [gruposDoForm, setGruposDoForm] = useState([]);
  /* IDs a deletar no submit */
  const [gruposExcluir, setGruposExcluir] = useState([]);
  const [itensExcluir, setItensExcluir] = useState([]);
  /* Modal/form de grupo em edicao (null = nenhum) */
  const [editandoGrupo, setEditandoGrupo] = useState(null); // { _key, nome, min_escolhas, max_escolhas, ordem }
  /* Modal/form de item em edicao (null = nenhum) */
  const [editandoItem, setEditandoItem] = useState(null); // { grupoKey, item: { _key, nome, preco, imagem_url, ordem } }

  const handleUploadProd = async (file) => {
    setUploadingProd(true);
    try { const r = await uploadArquivo(file, "produto"); if (r.url) setFProd(p => ({ ...p, imagem_url: r.url })); }
    catch (e) { notify("Erro upload: " + e.message, false); }
    setUploadingProd(false);
  };

  const handleUploadCaixa = async (file) => {
    setUploadingCaixa(true);
    try { const r = await uploadArquivo(file, "caixinha"); if (r.url) setFCaixa(p => ({ ...p, imagem_url: r.url })); }
    catch (e) { notify("Erro upload: " + e.message, false); }
    setUploadingCaixa(false);
  };

  /* ── PROMOÇÕES ── */
  const emptyPromo = { titulo: "", descricao: "", preco_original: "", preco_promocional: "", imagem_url: "", produto_id: "", categoria_id: "", ativo: "1", validade: "" };
  const [promocoes,      setPromocoes]      = useState([]);
  const [promoForm,      setPromoForm]      = useState({ ...emptyPromo });
  const [promoEdit,      setPromoEdit]      = useState(null);
  const [promoSalvando,  setPromoSalvando]  = useState(false);
  const [promoOk,        setPromoOk]        = useState("");
  const [uploadingPromo, setUploadingPromo] = useState(false);

  const notify = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 2800); };

  const fetchData = useCallback(async () => {
    try {
      const [rC, rS, rP, rA, rCx] = await Promise.all([
        get("categorias_loja",   { loja_id: lojaId }),
        get("subcategorias",     { loja_id: lojaId }),
        get("produtos",          { loja_id: lojaId }),
        get("adicionais",        { loja_id: lojaId }),
        get("caixinha_surpresa", { loja_id: lojaId }),
      ]);
      setCategorias(rC.dados  || []);
      setSubcategorias(rS.dados || []);
      setProdutos(rP.dados    || []);
      setAdicionais(rA.dados  || []);
      setCaixinhas(rCx.dados  || []);
    } catch (e) { console.error(e); }
  }, [lojaId]);

  const fetchPromocoes = useCallback(async () => {
    try { const r = await get("promocoes", { loja_id: lojaId }); setPromocoes(toArr(r.dados)); }
    catch (e) { console.error(e); }
  }, [lojaId]);

  useEffect(() => {
    if (sub === "promocoes") { fetchPromocoes(); fetchData(); }
    else fetchData();
  }, [fetchData, fetchPromocoes, sub]);

  const [salvando, setSalvando] = useState(false);

  /* ── SUBMIT GENÉRICO (POST ou PUT) ── */
  const submitForm = async (modulo, body, label, resetFn, editId = null) => {
    if (salvando) return;
    setSalvando(true);
    try {
      const payload = { ...body, loja_id: lojaId };
      /* desmascarar campos de preço APENAS para módulos que os possuem */
      const modulosComPreco = ["produtos", "adicionais", "caixinha_surpresa", "promocoes"];
      if (modulosComPreco.includes(modulo)) {
        ["preco","preco_original","preco_promocional","cashback_pct"].forEach(k => {
          if (payload[k]) payload[k] = desmascarar(payload[k]);
          else if (payload[k] === "" || payload[k] === undefined) payload[k] = "0";
        });
      }
      let ok = false;
      if (editId) {
        const res = await put(modulo, editId, payload);
        ok = !!(res && (res.mensagem || res.sucesso || res.ok));
        if (ok) notify(`${label} atualizado(a)!`);
        else notify((res && res.error) || "Erro ao atualizar", false);
      } else {
        const res = await post(modulo, payload);
        ok = !!(res && (res.id || res.sucesso));
        if (ok) notify(`${label} cadastrado(a)!`);
        else notify((res && res.error) || "Erro ao cadastrar", false);
      }
      if (ok) {
        await fetchData();
        resetFn();
      }
    } catch (e) {
      notify("Erro: " + (e.message || ""), false);
    } finally {
      setSalvando(false);
    }
  };

  /* ── EXCLUIR GENÉRICO ── */
  const excluir = async (modulo, id, label) => {
    if (salvando) return;
    if (!window.confirm(`Excluir este(a) ${label}?`)) return;
    setSalvando(true);
    try {
      const res = await del(modulo, id);
      const ok = !!(res && (res.mensagem || res.sucesso || res.ok));
      if (ok) {
        notify(`${label} excluído(a)!`);
        await fetchData();
      } else {
        notify((res && res.error) || "Erro ao excluir", false);
      }
    } catch (e) {
      notify("Erro: " + (e.message || ""), false);
    } finally {
      setSalvando(false);
    }
  };

  /* ── COPIAR: preenche formulário sem id ── */
  const copiarProd = (p) => {
    setEditProd(null);
    setFProd({ nome: p.nome + " (cópia)", descricao: p.descricao || "", preco: mascaraPreco(Math.round(parseFloat(p.preco||0)*100)), preco_promocional: p.preco_promocional ? mascaraPreco(Math.round(parseFloat(p.preco_promocional)*100)) : "", categoria_id: p.categoria_id || "", subcategoria_id: p.subcategoria_id || "", disponivel: "1", destaque: String(p.destaque || "0"), ordem: String(p.ordem || "0"), tempo_preparo: String(p.tempo_preparo || "15"), cashback_pct: String(p.cashback_pct || "0"), imagem_url: p.imagem_url || "" });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const copiarCaixa = (c) => {
    setEditCaixa(null);
    setFCaixa({ nome: c.nome + " (cópia)", descricao: c.descricao || "", preco: mascaraPreco(Math.round(parseFloat(c.preco||0)*100)), preco_original: mascaraPreco(Math.round(parseFloat(c.preco_original||0)*100)), quantidade_limite: c.quantidade_limite || "", ativo: "1", imagem_url: c.imagem_url || "" });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ── GRUPOS DE ADICIONAIS NO FORM DE PRODUTO ── */
  const novoKey = () => Date.now() + Math.random();

  // Abrir modal pra novo grupo
  const abrirNovoGrupo = () => setEditandoGrupo({ _key: novoKey(), nome: "", min_escolhas: "0", max_escolhas: "1", ordem: String(gruposDoForm.length), _novo: true });
  // Abrir modal pra editar grupo existente
  const editarGrupo = (g) => setEditandoGrupo({ _key: g._key, nome: g.nome, min_escolhas: String(g.min_escolhas || "0"), max_escolhas: String(g.max_escolhas || "1"), ordem: String(g.ordem || "0"), _existeId: g.id || null });
  // Salvar grupo (novo ou edicao)
  const salvarGrupo = () => {
    if (!editandoGrupo.nome.trim()) { notify("Nome do grupo obrigatório", false); return; }
    setGruposDoForm(p => {
      const existe = p.find(g => g._key === editandoGrupo._key);
      if (existe) {
        return p.map(g => g._key === editandoGrupo._key
          ? { ...g, nome: editandoGrupo.nome.trim(), min_escolhas: editandoGrupo.min_escolhas, max_escolhas: editandoGrupo.max_escolhas, ordem: editandoGrupo.ordem, _dirty: true }
          : g);
      }
      return [...p, { _key: editandoGrupo._key, nome: editandoGrupo.nome.trim(), min_escolhas: editandoGrupo.min_escolhas, max_escolhas: editandoGrupo.max_escolhas, ordem: editandoGrupo.ordem, _novo: true, itens: [] }];
    });
    setEditandoGrupo(null);
  };
  // Excluir grupo (e todos os itens dele)
  const excluirGrupo = (g) => {
    if (!window.confirm(`Excluir grupo "${g.nome}" e todos os ${(g.itens||[]).length} item(ns)?`)) return;
    if (g.id) setGruposExcluir(p => [...p, g.id]);
    // marca itens existentes do grupo pra deletar tambem
    (g.itens || []).forEach(i => { if (i.id) setItensExcluir(p => [...p, i.id]); });
    setGruposDoForm(p => p.filter(x => x._key !== g._key));
  };
  // Duplicar grupo (cria copia com itens)
  const duplicarGrupo = (g) => {
    const copiaItens = (g.itens || []).map(i => ({ ...i, _key: novoKey(), _novo: true, id: undefined, _dirty: undefined }));
    setGruposDoForm(p => [...p, { ...g, _key: novoKey(), _novo: true, id: undefined, _dirty: undefined, nome: g.nome + " (cópia)", ordem: String(p.length), itens: copiaItens }]);
  };

  // Abrir modal pra novo item dentro de um grupo
  const abrirNovoItem = (grupoKey) => {
    const g = gruposDoForm.find(x => x._key === grupoKey);
    const ordem = g ? (g.itens || []).length : 0;
    setEditandoItem({ grupoKey, item: { _key: novoKey(), nome: "", preco: "", imagem_url: "", ordem: String(ordem), _novo: true } });
  };
  // Abrir modal pra editar item
  const editarItem = (grupoKey, item) => {
    setEditandoItem({ grupoKey, item: { ...item, _existeId: item.id || null } });
  };
  // Salvar item (novo ou edicao)
  const salvarItem = () => {
    if (!editandoItem.item.nome.trim()) { notify("Nome do item obrigatório", false); return; }
    const { grupoKey, item } = editandoItem;
    setGruposDoForm(p => p.map(g => {
      if (g._key !== grupoKey) return g;
      const itens = g.itens || [];
      const existe = itens.find(i => i._key === item._key);
      const novaLista = existe
        ? itens.map(i => i._key === item._key ? { ...i, ...item, _dirty: !item._novo } : i)
        : [...itens, item];
      return { ...g, itens: novaLista };
    }));
    setEditandoItem(null);
  };
  // Duplicar item dentro do mesmo grupo
  const duplicarItem = (grupoKey, item) => {
    setGruposDoForm(p => p.map(g => {
      if (g._key !== grupoKey) return g;
      const itens = g.itens || [];
      return { ...g, itens: [...itens, { ...item, _key: novoKey(), _novo: true, id: undefined, _dirty: undefined, nome: item.nome + " (cópia)" }] };
    }));
  };
  // Excluir item
  const excluirItem = (grupoKey, item) => {
    if (item.id) setItensExcluir(p => [...p, item.id]);
    setGruposDoForm(p => p.map(g => g._key === grupoKey ? { ...g, itens: (g.itens || []).filter(i => i._key !== item._key) } : g));
  };

  // Carregar grupos+itens existentes do produto ao editar
  const carregarGruposDoProduto = async (produtoId) => {
    try {
      const r = await get("adicionais", { acao: "grupos", produto_id: produtoId, loja_id: lojaId });
      const lista = (r.dados || []).map(g => ({
        _key: g.id,
        id: g.id,
        nome: g.nome || "",
        min_escolhas: String(g.min_escolhas || "0"),
        max_escolhas: String(g.max_escolhas || "1"),
        ordem: String(g.ordem || "0"),
        itens: (g.itens || []).map(i => ({
          _key: i.id,
          id: i.id,
          nome: i.nome || "",
          preco: i.preco && parseFloat(i.preco) > 0 ? mascaraPreco(Math.round(parseFloat(i.preco) * 100)) : "",
          imagem_url: i.imagem_url || "",
          ordem: String(i.ordem || "0"),
        })),
      }));
      setGruposDoForm(lista);
    } catch(e) { setGruposDoForm([]); }
  };

  // Copiar grupos+itens de OUTRO produto (acrescenta como novos)
  const [copiarDeProdutoId, setCopiarDeProdutoId] = useState("");
  const [copiandoAdis, setCopiandoAdis] = useState(false);
  const copiarAdisDeOutroProduto = async () => {
    if (!copiarDeProdutoId) { notify("Selecione um produto", false); return; }
    setCopiandoAdis(true);
    try {
      const r = await get("adicionais", { acao: "grupos", produto_id: copiarDeProdutoId, loja_id: lojaId });
      const dados = r.dados || [];
      if (dados.length === 0) { notify("Esse produto não tem adicionais", false); setCopiandoAdis(false); return; }
      const novos = dados.map(g => ({
        _key: novoKey(),
        _novo: true,
        nome: g.nome || "",
        min_escolhas: String(g.min_escolhas || "0"),
        max_escolhas: String(g.max_escolhas || "1"),
        ordem: String(g.ordem || "0"),
        itens: (g.itens || []).map(i => ({
          _key: novoKey(),
          _novo: true,
          nome: i.nome || "",
          preco: i.preco && parseFloat(i.preco) > 0 ? mascaraPreco(Math.round(parseFloat(i.preco) * 100)) : "",
          imagem_url: i.imagem_url || "",
          ordem: String(i.ordem || "0"),
        })),
      }));
      setGruposDoForm(p => [...p, ...novos]);
      notify(novos.length + " grupo(s) copiado(s)!");
      setCopiarDeProdutoId("");
    } catch(e) { notify("Erro ao copiar: " + (e.message || ""), false); }
    setCopiandoAdis(false);
  };

  const submitProduto = async () => {
    if (salvando) return;
    if (!fProd.nome || !fProd.preco) { notify("Nome e preço são obrigatórios", false); return; }
    setSalvando(true);
    try {
      const payload = { ...fProd, loja_id: lojaId, preco: desmascarar(fProd.preco), preco_promocional: fProd.preco_promocional ? desmascarar(fProd.preco_promocional) : null, imagem_url: fProd.imagem_url || null, cashback_pct: fProd.cashback_pct || "0" };
      let prodId = editProd;
      if (editProd) {
        const res = await put("produtos", editProd, payload);
        if (!res || !(res.mensagem || res.sucesso)) {
          notify((res && res.error) || "Erro ao atualizar produto", false);
          setSalvando(false);
          return;
        }
      } else {
        const res = await post("produtos", payload);
        if (!res || !res.id) {
          notify((res && res.error) || "Erro ao cadastrar produto", false);
          setSalvando(false);
          return;
        }
        prodId = res.id;
      }
      /* ── SINCRONIZAR GRUPOS DE ADICIONAIS + ITENS ── */
      // 1) Excluir grupos marcados (e seus itens automaticamente)
      for (const idDel of gruposExcluir) {
        try { await post("adicionais", { acao: "excluir_grupo", id: idDel }); } catch(e) {}
      }
      // 2) Excluir itens marcados (orfaos de grupos que continuam)
      for (const idDel of itensExcluir) {
        try { await del("adicionais", idDel); } catch(e) {}
      }
      // 3) Pra cada grupo: salva grupo (POST/PUT) e depois sincroniza itens
      for (const g of gruposDoForm) {
        let grupoId = g.id;
        const payloadGrupo = {
          acao: "salvar_grupo",
          produto_id: prodId,
          loja_id: lojaId,
          nome: g.nome,
          min_escolhas: parseInt(g.min_escolhas || "0", 10),
          max_escolhas: parseInt(g.max_escolhas || "1", 10),
          ordem: parseInt(g.ordem || "0", 10),
          ativo: 1,
        };
        try {
          if (grupoId) payloadGrupo.id = grupoId;
          const r = await post("adicionais", payloadGrupo);
          if (r && r.id) grupoId = r.id;
        } catch(e) { continue; }

        // Salvar/atualizar itens do grupo
        for (const it of (g.itens || [])) {
          const payloadItem = {
            nome: it.nome,
            preco: desmascarar(it.preco) || "0",
            imagem_url: it.imagem_url || null,
            ordem: parseInt(it.ordem || "0", 10),
            grupo_id: grupoId,
            produto_id: prodId,
            categoria_id: fProd.categoria_id || null,
            loja_id: lojaId,
          };
          try {
            if (it.id) await put("adicionais", it.id, payloadItem);
            else       await post("adicionais", payloadItem);
          } catch(e) {}
        }
      }
      notify(editProd ? "Produto atualizado!" : "Produto cadastrado!");
      await fetchData();
      setEditProd(null);
      setFProd({ nome: "", descricao: "", preco: "", preco_promocional: "", categoria_id: "", subcategoria_id: "", disponivel: "1", destaque: "0", ordem: "0", tempo_preparo: "15", cashback_pct: "0", imagem_url: "" });
      setGruposDoForm([]);
      setGruposExcluir([]);
      setItensExcluir([]);
      setEditandoGrupo(null);
      setEditandoItem(null);
    } catch (e) {
      notify("Erro: " + (e.message || ""), false);
    } finally {
      setSalvando(false);
    }
  };

  /* CRUD Promoções */
  const salvarPromo = async () => {
    if (!promoForm.titulo) { notify("Título é obrigatório", false); return; }
    if (!promoForm.categoria_id) { notify("Selecione uma categoria", false); return; }
    setPromoSalvando(true);
    try {
      const body = { ...promoForm, loja_id: lojaId };
      ["preco_original","preco_promocional"].forEach(k => { if (body[k]) body[k] = desmascarar(body[k]); });
      if (promoEdit) { await put("promocoes", promoEdit, body); setPromoEdit(null); }
      else           { await post("promocoes", body); }
      await fetchPromocoes();
      setPromoForm({ ...emptyPromo });
      setPromoOk(promoEdit ? "Promoção atualizada!" : "Promoção criada com sucesso!");
      setTimeout(() => setPromoOk(""), 3000);
    } catch (e) { notify("Erro: " + e.message, false); }
    setPromoSalvando(false);
  };
  const deletarPromo = async (id) => {
    if (!window.confirm("Remover esta promoção?")) return;
    try { await del("promocoes", id); fetchPromocoes(); notify("Promoção removida"); }
    catch (e) { notify("Erro ao remover", false); }
  };
  const togglePromo = async (p) => {
    const ativa = String(p.ativo) === "1";
    try { await put("promocoes", p.id, { ativo: ativa ? "0" : "1" }); fetchPromocoes(); }
    catch (e) { notify("Erro", false); }
  };
  const handleUploadPromo = async (file) => {
    setUploadingPromo(true);
    try { const r = await uploadArquivo(file, "promocoes"); if (r.url) setPromoForm(p => ({ ...p, imagem_url: r.url, produto_id: "" })); }
    catch (e) { notify("Erro upload: " + e.message, false); }
    setUploadingPromo(false);
  };
  const selecionarProduto = (prodId) => {
    if (!prodId) { setPromoForm(p => ({ ...p, produto_id: "", imagem_url: "", titulo: "", descricao: "", preco_original: "", preco_promocional: "" })); return; }
    const prod = produtos.find(p => String(p.id) === String(prodId));
    if (!prod) return;
    setPromoForm(p => ({
      ...p,
      produto_id: prodId,
      imagem_url: prod.imagem_url || "",
      titulo: prod.nome || "",
      descricao: prod.descricao || "",
      preco_original: prod.preco ? mascaraPreco(Math.round(parseFloat(prod.preco) * 100)) : "",
    }));
  };
  const descPct = (orig, promo) => { const o = parseFloat(orig), p = parseFloat(promo); if (!o || !p || o <= 0) return 0; return Math.round((1 - p / o) * 100); };

  /* Estilos comuns */
  const iS = { width:"100%", padding:"12px 14px", borderRadius:10, border:`1px solid ${C.border}`, background:C.bg, color:C.text, fontSize:14, fontFamily:"inherit", outline:"none" };
  const lS = { fontSize:12, fontWeight:600, color:C.textSoft, marginBottom:6, display:"block" };
  const bS = { padding:14, borderRadius:12, border:"none", color:"#fff", fontWeight:700, fontSize:15, background:C.green, marginTop:12, cursor:"pointer", width:"100%" };
  const bEditS = { ...bS, background:"#3B82F6", marginTop:0 };

  const listCard = (children) => (
    <div style={{ padding:"14px 16px", background:C.bg, borderRadius:12, border:`1px solid ${C.border}`, marginBottom:8 }}>
      {children}
    </div>
  );

  const titles = { categorias:"Categorias", subcategorias:"Sub Categorias", produtos:"Produtos", adicionais:"Adicionais", caixinha:"Caixinha Surpresa", promocoes:"Promoções do Dia", catalogo:"Catálogo Web" };

  /* ══════════════════════ RENDER CATÁLOGO WEB ══════════════════════ */
  if (sub === "catalogo") {
    return <CatalogoWeb lojaId={lojaId} C={C} />;
  }

  /* ══════════════════════ RENDER PROMOÇÕES ══════════════════════ */
  if (sub === "promocoes") {
    const RED = "#E8201A";
    return (
      <div style={{ animation:"fadeUp .4s ease-out" }}>
        <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:28 }}>
          <div style={{ width:52, height:52, borderRadius:16, background:`${RED}18`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:26 }}>🔥</div>
          <div>
            <h1 style={{ fontFamily:"'Plus Jakarta Sans'", fontWeight:800, fontSize:28 }}>Promoções do Dia</h1>
            <p style={{ fontSize:13, color:C.textMuted, marginTop:2 }}>Crie ofertas relâmpago que aparecem no app dos clientes</p>
          </div>
          <div style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:8, padding:"8px 16px", borderRadius:10, background:`${RED}12`, border:`1px solid ${RED}30` }}>
            <div style={{ width:7, height:7, borderRadius:"50%", background:RED, animation:"pulse 1.5s infinite" }} />
            <span style={{ fontSize:12, fontWeight:700, color:RED }}>AO VIVO NO APP</span>
          </div>
        </div>

        {toast && <div style={{ position:"fixed", top:20, left:"50%", transform:"translateX(-50%)", zIndex:999, background:toast.ok ? C.green : RED, color:"#fff", padding:"12px 28px", borderRadius:12, fontWeight:700, fontSize:14, animation:"slideDown .3s ease-out" }}>{toast.msg}</div>}

        <div style={{ display:"grid", gridTemplateColumns:"420px 1fr", gap:24 }}>
          {/* FORMULÁRIO */}
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:18, padding:26, height:"fit-content", position:"sticky", top:24 }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20 }}>
              <h3 style={{ fontSize:16, fontWeight:700, color:C.text }}>{promoEdit ? "✏️ Editando promoção" : "✨ Nova promoção"}</h3>
              {promoEdit && <button onClick={() => { setPromoEdit(null); setPromoForm({ ...emptyPromo }); }} style={{ fontSize:12, color:C.textMuted, background:"transparent", border:`1px solid ${C.border}`, cursor:"pointer", padding:"4px 10px", borderRadius:6 }}>✕ Cancelar</button>}
            </div>
            {/* PREVIEW */}
            <div style={{ marginBottom:20, borderRadius:16, overflow:"hidden", height:160, position:"relative", background:promoForm.imagem_url ? "#111" : RED, boxShadow:"0 8px 32px rgba(0,0,0,0.35)" }}>
              {promoForm.imagem_url && <img src={promoForm.imagem_url} alt="" style={{ width:"100%", height:"100%", objectFit:"cover", opacity:0.9 }} />}
              {!promoForm.imagem_url && (
                <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:8, padding:"0 24px" }}>
                  <span style={{ fontSize:36, opacity:0.5 }}>📸</span>
                  <span style={{ color:"rgba(255,255,255,.7)", fontWeight:600, fontSize:13, textAlign:"center" }}>Selecione um produto ou envie uma foto</span>
                </div>
              )}
              {(promoForm.titulo || promoForm.preco_promocional) && (
                <div style={{ position:"absolute", bottom:0, left:0, right:0, padding:"18px 16px 14px", background:"linear-gradient(transparent,rgba(0,0,0,.82))" }}>
                  {promoForm.titulo && <div style={{ color:"#fff", fontWeight:800, fontSize:15, marginBottom:4 }}>{promoForm.titulo}</div>}
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    {promoForm.preco_original && <span style={{ color:"rgba(255,255,255,.55)", fontSize:12, textDecoration:"line-through" }}>R$ {parseFloat(desmascarar(promoForm.preco_original)||0).toFixed(2).replace(".",",")}</span>}
                    {promoForm.preco_promocional && <span style={{ color:"#FACC15", fontWeight:800, fontSize:17 }}>R$ {parseFloat(desmascarar(promoForm.preco_promocional)||0).toFixed(2).replace(".",",")}</span>}
                  </div>
                </div>
              )}
              {descPct(desmascarar(promoForm.preco_original), desmascarar(promoForm.preco_promocional)) > 0 && (
                <div style={{ position:"absolute", top:12, right:12, background:"#FACC15", color:"#000", fontWeight:900, fontSize:13, padding:"5px 13px", borderRadius:24 }}>
                  {descPct(desmascarar(promoForm.preco_original), desmascarar(promoForm.preco_promocional))}% OFF
                </div>
              )}
              <div style={{ position:"absolute", top:12, left:12, background:"rgba(0,0,0,.5)", color:"rgba(255,255,255,.7)", fontSize:9, fontWeight:700, padding:"3px 8px", borderRadius:6 }}>PREVIEW</div>
            </div>
            {/* CAMPOS */}
            <div style={{ display:"flex", flexDirection:"column", gap:13 }}>
              {/* Selecionar Produto */}
              <div>
                <label style={lS}>Selecionar Produto</label>
                <select value={promoForm.produto_id || ""} onChange={e => selecionarProduto(e.target.value)} style={iS}>
                  <option value="">— Escolha um produto (ou preencha manualmente) —</option>
                  {produtos.map(p => (
                    <option key={p.id} value={p.id}>{p.nome} — R$ {parseFloat(p.preco||0).toFixed(2).replace(".",",")}</option>
                  ))}
                </select>
                {promoForm.produto_id && (
                  <div style={{ marginTop:6, fontSize:11, color:C.greenLight, fontWeight:600 }}>✓ Produto vinculado — dados preenchidos automaticamente</div>
                )}
              </div>
              <div><label style={lS}>Título *</label><input value={promoForm.titulo} onChange={e => setPromoForm(p => ({ ...p, titulo:e.target.value }))} placeholder="Ex: X-Bacon com 40% OFF hoje!" style={iS} /></div>
              <div><label style={lS}>Descrição</label><input value={promoForm.descricao} onChange={e => setPromoForm(p => ({ ...p, descricao:e.target.value }))} placeholder="Só hoje! Aproveite enquanto dura..." style={iS} /></div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                <div><label style={lS}>Preço Original</label><input inputMode="numeric" value={promoForm.preco_original} onChange={e => setPromoForm(p => ({ ...p, preco_original:mascaraPreco(e.target.value.replace(/\D/g,"")) }))} placeholder="0,00" style={iS} /></div>
                <div><label style={lS}>Preço Promocional</label><input inputMode="numeric" value={promoForm.preco_promocional} onChange={e => setPromoForm(p => ({ ...p, preco_promocional:mascaraPreco(e.target.value.replace(/\D/g,"")) }))} placeholder="0,00" style={iS} /></div>
              </div>
              <div><label style={lS}>Válido até (opcional)</label><input type="date" value={promoForm.validade} onChange={e => setPromoForm(p => ({ ...p, validade:e.target.value }))} style={iS} /></div>
              <div>
                <label style={lS}>Categoria *</label>
                <select value={promoForm.categoria_id || ""} onChange={e => setPromoForm(p => ({ ...p, categoria_id:e.target.value }))} style={iS}>
                  <option value="">— Em qual categoria a promoção aparece?</option>
                  {categorias.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                </select>
                <div style={{ fontSize:11, color:C.textMuted, marginTop:4 }}>Crie uma categoria "Promoções do Dia" se quiser destacar</div>
              </div>
              <div>
                <label style={lS}>Foto personalizada (opcional — sobrescreve a do produto)</label>
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <label style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 16px", background:C.bg, border:`1px dashed ${uploadingPromo ? C.greenLight : C.border}`, borderRadius:10, cursor:"pointer", color:C.text, fontSize:13, flex:1, justifyContent:"center" }}>
                    {uploadingPromo ? <><div style={{ width:13, height:13, border:`2px solid ${C.greenLight}`, borderTopColor:"transparent", borderRadius:"50%", animation:"spin 1s linear infinite" }} /><span style={{ color:C.greenLight, fontWeight:600 }}>Enviando...</span></> : <><span>📸</span><span>{promoForm.imagem_url ? "Trocar foto" : "Enviar foto"}</span></>}
                    <input type="file" accept="image/*" style={{ display:"none" }} disabled={uploadingPromo} onChange={e => { if (e.target.files[0]) handleUploadPromo(e.target.files[0]); e.target.value=""; }} />
                  </label>
                  {promoForm.imagem_url && <button onClick={() => setPromoForm(p => ({ ...p, imagem_url:"" }))} style={{ padding:"10px 14px", background:`${RED}18`, border:`1px solid ${RED}30`, borderRadius:10, color:RED, cursor:"pointer", fontSize:13, fontWeight:600 }}>✕</button>}
                </div>
                {promoForm.imagem_url && <div style={{ marginTop:8, display:"flex", alignItems:"center", gap:8 }}><img src={promoForm.imagem_url} alt="" style={{ width:48, height:48, borderRadius:8, objectFit:"cover", border:`1px solid ${C.border}` }} /><span style={{ fontSize:11, color:C.greenLight, fontWeight:600 }}>✓ Imagem selecionada</span></div>}
              </div>
              {promoOk && <div style={{ padding:"11px 14px", background:`${C.greenLight}18`, border:`1px solid ${C.greenLight}40`, borderRadius:9, color:C.greenLight, fontSize:13, fontWeight:700 }}>✓ {promoOk}</div>}
              <button onClick={salvarPromo} disabled={promoSalvando} style={{ ...bS, background:promoSalvando ? C.border : `linear-gradient(135deg,${RED},#FF4444)`, color:promoSalvando ? C.textMuted : "#fff", boxShadow:promoSalvando ? "none" : `0 4px 20px ${RED}35`, marginTop:0 }}>
                {promoSalvando ? "Salvando..." : promoEdit ? "💾 Salvar Alterações" : "🔥 Publicar Promoção"}
              </button>
            </div>
          </div>
          {/* LISTA */}
          <div>
            <div style={{ marginBottom:16 }}>
              <h3 style={{ fontSize:17, fontWeight:700, color:C.text }}>Promoções cadastradas</h3>
              <p style={{ fontSize:12, color:C.textMuted, marginTop:2 }}>{promocoes.filter(p => String(p.ativo) === "1").length} ativa(s) · {promocoes.length} total</p>
            </div>
            {promocoes.length === 0 ? (
              <div style={{ textAlign:"center", padding:"56px 32px", background:C.card, borderRadius:18, border:`2px dashed ${C.border}` }}>
                <div style={{ fontSize:52, marginBottom:14, opacity:.5 }}>🏷️</div>
                <div style={{ fontWeight:700, fontSize:16, color:C.text, marginBottom:6 }}>Nenhuma promoção ainda</div>
                <div style={{ fontSize:13, color:C.textMuted }}>Crie sua primeira promoção no formulário ao lado</div>
              </div>
            ) : (
              <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                {promocoes.map((p) => {
                  const pct = descPct(p.preco_original, p.preco_promocional);
                  const ativa = String(p.ativo) === "1";
                  const temImg = p.imagem_url && p.imagem_url.trim() !== "";
                  return (
                    <div key={p.id} style={{ background:C.card, borderRadius:16, overflow:"hidden", display:"flex", alignItems:"stretch", border:`1px solid ${C.border}`, opacity:ativa ? 1 : 0.55, transition:"all .2s" }}>
                      <div style={{ width:110, flexShrink:0, position:"relative", background:temImg ? "#111" : RED, display:"flex", alignItems:"center", justifyContent:"center", minHeight:96 }}>
                        {temImg && <img src={p.imagem_url} alt="" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover" }} />}
                        {!temImg && <span style={{ fontSize:28, opacity:0.4 }}>📸</span>}
                        {pct > 0 && <div style={{ position:"absolute", top:8, right:8, background:"#FACC15", color:"#000", fontWeight:900, fontSize:10, padding:"2px 8px", borderRadius:12 }}>-{pct}%</div>}
                        {!ativa && <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,.55)", display:"flex", alignItems:"center", justifyContent:"center" }}><span style={{ fontSize:18 }}>⏸</span></div>}
                      </div>
                      <div style={{ flex:1, padding:"14px 16px", display:"flex", flexDirection:"column", justifyContent:"space-between", minWidth:0 }}>
                        <div>
                          <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:3, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{p.titulo}</div>
                          {p.descricao && <div style={{ fontSize:12, color:C.textMuted, marginBottom:8, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{p.descricao}</div>}
                          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                            {p.preco_original && <span style={{ fontSize:12, color:C.textMuted, textDecoration:"line-through" }}>R$ {parseFloat(p.preco_original).toFixed(2).replace(".",",")}</span>}
                            {p.preco_promocional && <span style={{ fontSize:18, fontWeight:800, color:C.greenLight }}>R$ {parseFloat(p.preco_promocional).toFixed(2).replace(".",",")}</span>}
                            {pct > 0 && <span style={{ fontSize:11, fontWeight:800, background:"#FACC1520", color:"#FACC15", padding:"3px 10px", borderRadius:10 }}>🔥 {pct}% OFF</span>}
                          </div>
                        </div>
                        <div style={{ display:"flex", gap:8, alignItems:"center", marginTop:8 }}>
                          <span style={{ fontSize:11, padding:"3px 10px", borderRadius:6, fontWeight:700, background:ativa ? `${C.greenLight}20` : `${RED}18`, color:ativa ? C.greenLight : RED }}>{ativa ? "● Ativa" : "○ Pausada"}</span>
                          {p.validade && <span style={{ fontSize:11, color:C.textMuted }}>📅 até {new Date(p.validade+"T12:00:00").toLocaleDateString("pt-BR")}</span>}
                        </div>
                      </div>
                      <div style={{ display:"flex", flexDirection:"column", gap:6, padding:"14px 12px", justifyContent:"center", borderLeft:`1px solid ${C.border}` }}>
                        <button onClick={() => { setPromoEdit(p.id); setPromoForm({ titulo:p.titulo||"", descricao:p.descricao||"", preco_original:p.preco_original ? mascaraPreco(Math.round(parseFloat(p.preco_original)*100)) : "", preco_promocional:p.preco_promocional ? mascaraPreco(Math.round(parseFloat(p.preco_promocional)*100)) : "", imagem_url:p.imagem_url||"", produto_id:p.produto_id||"", categoria_id:String(p.categoria_id||""), ativo:p.ativo, validade:p.validade ? String(p.validade).split("T")[0] : "" }); window.scrollTo({ top:0, behavior:"smooth" }); }} style={{ padding:"7px 14px", borderRadius:8, border:`1px solid ${C.border}`, background:"transparent", color:C.text, cursor:"pointer", fontSize:12, fontWeight:600 }}>✏️ Editar</button>
                        <button onClick={() => togglePromo(p)} style={{ padding:"7px 14px", borderRadius:8, border:"none", background:ativa ? `${RED}18` : `${C.greenLight}18`, color:ativa ? RED : C.greenLight, cursor:"pointer", fontSize:12, fontWeight:700 }}>{ativa ? "⏸ Pausar" : "▶ Ativar"}</button>
                        <button onClick={() => deletarPromo(p.id)} style={{ padding:"7px 14px", borderRadius:8, border:"none", background:`${RED}12`, color:RED, cursor:"pointer", fontSize:12, fontWeight:700 }}>🗑 Excluir</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  /* ══════════════════════ RENDER PADRÃO ══════════════════════ */
  const editando = editCat || editSub || editProd || editAdi || editCaixa;

  return (
    <div style={{ animation:"fadeUp .4s ease-out" }}>
      <div style={{ marginBottom:24, display:"flex", alignItems:"center", gap:12 }}>
        <h1 style={{ fontFamily:"'Plus Jakarta Sans'", fontWeight:800, fontSize:28 }}>{titles[sub]}</h1>
        {editando && (
          <span style={{ fontSize:12, background:"#3B82F618", color:"#3B82F6", border:"1px solid #3B82F630", borderRadius:8, padding:"4px 12px", fontWeight:700 }}>
            ✏️ Modo edição — preencha e salve
          </span>
        )}
      </div>

      {toast && <div style={{ position:"fixed", top:20, left:"50%", transform:"translateX(-50%)", zIndex:999, background:toast.ok ? C.green : C.red, color:"#fff", padding:"12px 28px", borderRadius:12, fontWeight:700, fontSize:14, animation:"slideDown .3s ease-out" }}>{toast.msg}</div>}

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:20 }}>

        {/* ── FORMULÁRIO ── */}
        <Card>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
            <h3 style={{ fontSize:18, fontWeight:700 }}>{editando ? "✏️ Editar" : "Novo Cadastro"}</h3>
            {editando && (
              <button onClick={() => { setEditCat(null); setEditSub(null); setEditProd(null); setEditAdi(null); setEditCaixa(null); setFCat({ nome:"", descricao:"", ordem:"0" }); setFSub({ nome:"", categoria_id:"", descricao:"" }); setFProd({ nome:"", descricao:"", preco:"", preco_promocional:"", categoria_id:"", subcategoria_id:"", disponivel:"1", destaque:"0", ordem:"0", tempo_preparo:"15", cashback_pct:"0", imagem_url:"" }); setFAdi({ nome:"", preco:"", categoria_id:"", produto_id:"", grupo_nome:"", obrigatorio:"0", max_escolhas:"1", imagem_url:"" }); setFCaixa({ nome:"", descricao:"", preco:"", preco_original:"", quantidade_limite:"", ativo:"1", imagem_url:"" }); setGruposDoForm([]); setGruposExcluir([]); setItensExcluir([]); setEditandoGrupo(null); setEditandoItem(null); }}
                style={{ fontSize:12, color:C.textMuted, background:"transparent", border:`1px solid ${C.border}`, cursor:"pointer", padding:"4px 10px", borderRadius:6 }}>
                ✕ Cancelar
              </button>
            )}
          </div>

          {/* CATEGORIAS */}
          {sub === "categorias" && <>
            <Field label="Nome da Categoria *" ph="Ex: Hambúrgueres" value={fCat.nome} onChange={v => setFCat({ ...fCat, nome:v })} />
            <Field label="Descrição" ph="Descrição da categoria" value={fCat.descricao} onChange={v => setFCat({ ...fCat, descricao:v })} />
            <Field label="Ordem" ph="0" type="number" value={fCat.ordem} onChange={v => setFCat({ ...fCat, ordem:v })} />
            <button disabled={salvando} onClick={() => submitForm("categorias_loja", fCat, "Categoria", () => { setFCat({ nome:"", descricao:"", ordem:"0" }); setEditCat(null); }, editCat)} style={editCat ? bEditS : bS}>
              {salvando ? "Salvando..." : (editCat ? "Salvar Alterações" : "Cadastrar Categoria")}
            </button>
          </>}

          {/* SUB CATEGORIAS */}
          {sub === "subcategorias" && <>
            <SelectField label="Categoria *" value={fSub.categoria_id} onChange={v => setFSub({ ...fSub, categoria_id:v })} options={[{ v:"", l:"Selecione" }, ...categorias.map(c => ({ v:c.id, l:c.nome }))]} />
            <Field label="Nome *" ph="Ex: Artesanais" value={fSub.nome} onChange={v => setFSub({ ...fSub, nome:v })} />
            <Field label="Descrição" ph="Descrição" value={fSub.descricao} onChange={v => setFSub({ ...fSub, descricao:v })} />
            <button disabled={salvando} onClick={() => submitForm("subcategorias", fSub, "Sub Categoria", () => { setFSub({ nome:"", categoria_id:"", descricao:"" }); setEditSub(null); }, editSub)} style={editSub ? bEditS : bS}>
              {salvando ? "Salvando..." : (editSub ? "Salvar Alterações" : "Cadastrar Sub Categoria")}
            </button>
          </>}

          {/* PRODUTOS */}
          {sub === "produtos" && <>
            <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:12 }}>
              <button onClick={() => setShowReajuste(true)} style={{ padding:"10px 16px", background:"linear-gradient(135deg, #F97316 0%, #E8201A 100%)", color:"#fff", border:"none", borderRadius:8, fontSize:13, fontWeight:800, cursor:"pointer", boxShadow:"0 4px 12px rgba(232,32,26,.3)" }}>
                ⚡ Reajuste em Massa
              </button>
            </div>
            <Field label="Nome do Produto *" ph="Ex: X-Bacon Duplo" value={fProd.nome} onChange={v => setFProd({ ...fProd, nome:v })} />
            <Field label="Descrição" ph="Ingredientes, detalhes..." value={fProd.descricao} onChange={v => setFProd({ ...fProd, descricao:v })} />
            <Field label="Preço (R$) *" ph="0,00" money value={fProd.preco} onChange={v => setFProd({ ...fProd, preco:v })} />
            <SelectField label="Categoria" value={fProd.categoria_id} onChange={v => setFProd({ ...fProd, categoria_id:v, subcategoria_id:"" })} options={[{ v:"", l:"Selecione" }, ...categorias.map(c => ({ v:c.id, l:c.nome }))]} />
            <SelectField label="Sub Categoria" value={fProd.subcategoria_id} onChange={v => setFProd({ ...fProd, subcategoria_id:v })} options={[{ v:"", l:"Nenhuma" }, ...subcategorias.filter(s => !fProd.categoria_id || String(s.categoria_id) === String(fProd.categoria_id)).map(s => ({ v:s.id, l:s.nome }))]} />
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
              <Field label="Preço Promocional" ph="0,00" money value={fProd.preco_promocional} onChange={v => setFProd({ ...fProd, preco_promocional:v })} />
              <Field label="Cashback %" ph="0" type="number" value={fProd.cashback_pct} onChange={v => setFProd({ ...fProd, cashback_pct:v })} />
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10 }}>
              <Field label="Ordem" ph="0" type="number" value={fProd.ordem} onChange={v => setFProd({ ...fProd, ordem:v })} />
              <Field label="Preparo (min)" ph="15" type="number" value={fProd.tempo_preparo} onChange={v => setFProd({ ...fProd, tempo_preparo:v })} />
              <SelectField label="Disponível" value={fProd.disponivel} onChange={v => setFProd({ ...fProd, disponivel:v })} options={[{ v:"1", l:"Sim" }, { v:"0", l:"Não" }]} />
            </div>
            <SelectField label="⭐ Destaque" value={fProd.destaque} onChange={v => setFProd({ ...fProd, destaque:v })} options={[{ v:"0", l:"Não" }, { v:"1", l:"Sim" }]} />

            {/* IMAGEM DO PRODUTO */}
            <div style={{ marginBottom: 14 }}>
              <label style={_lS}>Foto do Produto</label>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 16px", background: C.bg, border: `1px dashed ${uploadingProd ? C.greenLight : C.border}`, borderRadius: 10, cursor: "pointer", color: C.text, fontSize: 13, flex: 1, justifyContent: "center" }}>
                  {uploadingProd
                    ? <><div style={{ width: 13, height: 13, border: `2px solid ${C.greenLight}`, borderTopColor: "transparent", borderRadius: "50%", animation: "spin 1s linear infinite" }} /><span style={{ color: C.greenLight, fontWeight: 600 }}>Enviando...</span></>
                    : <><span>📸</span><span>{fProd.imagem_url ? "Trocar foto" : "Selecionar foto"}</span></>}
                  <input type="file" accept="image/*" style={{ display: "none" }} disabled={uploadingProd} onChange={e => { if (e.target.files[0]) handleUploadProd(e.target.files[0]); e.target.value = ""; }} />
                </label>
                {fProd.imagem_url && <button onClick={() => setFProd(p => ({ ...p, imagem_url: "" }))} style={{ padding: "10px 14px", background: "#E8201A18", border: "1px solid #E8201A30", borderRadius: 10, color: "#E8201A", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>✕</button>}
              </div>
              {fProd.imagem_url && (
                <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 8 }}>
                  <img src={fProd.imagem_url} alt="" style={{ width: 56, height: 56, borderRadius: 10, objectFit: "cover", border: `1px solid ${C.border}` }} />
                  <span style={{ fontSize: 11, color: C.greenLight, fontWeight: 600 }}>✓ Imagem selecionada</span>
                </div>
              )}
            </div>

            {/* ── GRUPOS DE ADICIONAIS (estilo iFood) ── */}
            <div style={{ marginTop:18, paddingTop:18, borderTop:`2px dashed ${C.border}` }}>
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:14 }}>
                <span style={{ fontSize:13, fontWeight:700, color:C.text }}>📦 Grupos de Adicionais</span>
                <span style={{ fontSize:11, color:C.textMuted }}>{gruposDoForm.length} grupo(s)</span>
              </div>

              {/* Copiar grupos de outro produto */}
              {produtos.length > 0 && (
                <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:14, padding:"10px 12px", background:`${C.blue}10`, border:`1px dashed ${C.blue}40`, borderRadius:10 }}>
                  <span style={{ fontSize:11, fontWeight:700, color:C.blue, flexShrink:0 }}>📋 Copiar de:</span>
                  <select value={copiarDeProdutoId} onChange={e => setCopiarDeProdutoId(e.target.value)} style={{ ..._iS, padding:"7px 10px", fontSize:12, flex:1 }}>
                    <option value="">— Selecione um produto —</option>
                    {produtos.filter(p => !editProd || p.id !== editProd).map(p => (
                      <option key={p.id} value={p.id}>#{p.id} — {p.nome}</option>
                    ))}
                  </select>
                  <button onClick={copiarAdisDeOutroProduto} disabled={!copiarDeProdutoId || copiandoAdis} style={{ padding:"7px 14px", borderRadius:7, border:"none", background:C.blue, color:"#fff", fontWeight:700, fontSize:12, cursor: copiarDeProdutoId && !copiandoAdis ? "pointer" : "not-allowed", opacity: copiarDeProdutoId && !copiandoAdis ? 1 : .5, flexShrink:0 }}>
                    {copiandoAdis ? "..." : "Copiar"}
                  </button>
                </div>
              )}

              {/* Lista de grupos */}
              {gruposDoForm.length === 0 && (
                <div style={{ padding:20, textAlign:"center", color:C.textMuted, fontSize:12, background:C.bg, border:`1px dashed ${C.border}`, borderRadius:10, marginBottom:10 }}>
                  Nenhum grupo cadastrado. Clique em &ldquo;+ Novo Grupo&rdquo; abaixo.
                </div>
              )}
              {gruposDoForm
                .slice()
                .sort((a, b) => (parseInt(a.ordem||"0",10) - parseInt(b.ordem||"0",10)))
                .map(g => {
                  const isObrig = parseInt(g.min_escolhas||"0",10) > 0;
                  return (
                    <div key={g._key} style={{ marginBottom:10, background:C.card, border:`1px solid ${C.border}`, borderRadius:10, overflow:"hidden" }}>
                      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 12px", background:`${C.green}08`, borderBottom:`1px solid ${C.border}` }}>
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ fontWeight:700, color:C.text, fontSize:13 }}>{g.nome || "(sem nome)"}</div>
                          <div style={{ fontSize:10, color:C.textMuted, marginTop:2 }}>
                            {isObrig ? <span style={{ color:"#E8201A", fontWeight:700 }}>OBRIGATÓRIO</span> : <span style={{ color:C.textMuted }}>opcional</span>}
                            <span style={{ margin:"0 6px" }}>·</span>
                            <span>min {g.min_escolhas||"0"} / máx {g.max_escolhas||"1"}</span>
                            <span style={{ margin:"0 6px" }}>·</span>
                            <span>ordem {g.ordem||"0"}</span>
                            <span style={{ margin:"0 6px" }}>·</span>
                            <span>{(g.itens||[]).length} item(s)</span>
                            {g.id && <span style={{ marginLeft:6, color:"#22C55E" }}>· salvo</span>}
                            {g._novo && <span style={{ marginLeft:6, color:"#1976D2" }}>· novo</span>}
                          </div>
                        </div>
                        <div style={{ display:"flex", gap:4, flexShrink:0 }}>
                          <button onClick={() => editarGrupo(g)} title="Editar grupo" style={{ background:"transparent", border:`1px solid ${C.border}`, borderRadius:6, padding:"5px 9px", cursor:"pointer", fontSize:12, color:C.text }}>✏️</button>
                          <button onClick={() => duplicarGrupo(g)} title="Duplicar grupo" style={{ background:"transparent", border:`1px solid ${C.border}`, borderRadius:6, padding:"5px 9px", cursor:"pointer", fontSize:12, color:C.text }}>📋</button>
                          <button onClick={() => excluirGrupo(g)} title="Excluir grupo" style={{ background:"transparent", border:"1px solid #E8201A30", borderRadius:6, padding:"5px 9px", cursor:"pointer", fontSize:12, color:"#E8201A" }}>🗑</button>
                        </div>
                      </div>
                      <div style={{ padding:"8px 12px" }}>
                        {(g.itens || [])
                          .slice()
                          .sort((a, b) => (parseInt(a.ordem||"0",10) - parseInt(b.ordem||"0",10)))
                          .map(it => (
                            <div key={it._key} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"6px 8px", marginBottom:4, background:C.bg, borderRadius:7, fontSize:12 }}>
                              <div style={{ display:"flex", alignItems:"center", gap:8, flex:1, minWidth:0 }}>
                                {it.imagem_url ? <img src={it.imagem_url} alt="" style={{ width:28, height:28, borderRadius:5, objectFit:"cover", flexShrink:0 }} /> : <div style={{ width:28, height:28, borderRadius:5, background:C.card, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, flexShrink:0 }}>📦</div>}
                                <div style={{ minWidth:0, flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                                  <span style={{ color:C.text, fontWeight:600 }}>{it.nome}</span>
                                  <span style={{ color:C.textMuted, marginLeft:6 }}>— {it.preco && it.preco !== "0,00" ? "R$ " + it.preco : "Grátis"}</span>
                                </div>
                              </div>
                              <div style={{ display:"flex", gap:3, flexShrink:0 }}>
                                <button onClick={() => editarItem(g._key, it)} title="Editar" style={{ background:"transparent", border:`1px solid ${C.border}`, borderRadius:5, padding:"3px 7px", cursor:"pointer", fontSize:11, color:C.text }}>✏️</button>
                                <button onClick={() => duplicarItem(g._key, it)} title="Duplicar" style={{ background:"transparent", border:`1px solid ${C.border}`, borderRadius:5, padding:"3px 7px", cursor:"pointer", fontSize:11, color:C.text }}>📋</button>
                                <button onClick={() => excluirItem(g._key, it)} title="Excluir" style={{ background:"transparent", border:"1px solid #E8201A30", borderRadius:5, padding:"3px 7px", cursor:"pointer", fontSize:11, color:"#E8201A" }}>🗑</button>
                              </div>
                            </div>
                          ))}
                        <button onClick={() => abrirNovoItem(g._key)} style={{ width:"100%", padding:"7px 0", marginTop:4, borderRadius:7, border:`1px dashed ${C.blue}`, background:`${C.blue}10`, color:C.blue, fontWeight:700, fontSize:11, cursor:"pointer" }}>
                          + Adicionar item ao grupo
                        </button>
                      </div>
                    </div>
                  );
                })}

              <button onClick={abrirNovoGrupo} style={{ width:"100%", padding:"12px 0", borderRadius:10, border:`1.5px dashed ${C.green}`, background:`${C.green}10`, color:C.green, fontWeight:700, fontSize:13, cursor:"pointer", marginTop:6 }}>
                + Novo Grupo de Adicionais
              </button>
            </div>

            {/* Modal: editor de grupo */}
            {editandoGrupo && (
              <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.5)", zIndex:9998, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }} onClick={() => setEditandoGrupo(null)}>
                <div onClick={e => e.stopPropagation()} style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:14, padding:18, maxWidth:480, width:"100%", maxHeight:"90vh", overflow:"auto" }}>
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:14 }}>
                    <span style={{ fontSize:15, fontWeight:800, color:C.text }}>{editandoGrupo._existeId ? "Editar Grupo" : "Novo Grupo"}</span>
                    <button onClick={() => setEditandoGrupo(null)} style={{ background:"none", border:"none", fontSize:18, color:C.textMuted, cursor:"pointer" }}>✕</button>
                  </div>
                  <div style={{ marginBottom:10 }}>
                    <label style={_lS}>Nome do Grupo *</label>
                    <input value={editandoGrupo.nome} onChange={e => setEditandoGrupo(p => ({ ...p, nome:e.target.value }))} placeholder="Ex: Escolha o ponto da carne" style={_iS} autoFocus />
                  </div>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:10 }}>
                    <div>
                      <label style={_lS}>Mín. escolhas</label>
                      <input type="number" min="0" value={editandoGrupo.min_escolhas} onChange={e => setEditandoGrupo(p => ({ ...p, min_escolhas:e.target.value }))} placeholder="0" style={_iS} />
                      <div style={{ fontSize:10, color:C.textMuted, marginTop:3 }}>{parseInt(editandoGrupo.min_escolhas||"0",10) > 0 ? "Obrigatório" : "Opcional"}</div>
                    </div>
                    <div>
                      <label style={_lS}>Máx. escolhas</label>
                      <input type="number" min="1" value={editandoGrupo.max_escolhas} onChange={e => setEditandoGrupo(p => ({ ...p, max_escolhas:e.target.value }))} placeholder="1" style={_iS} />
                    </div>
                    <div>
                      <label style={_lS}>Ordem</label>
                      <input type="number" value={editandoGrupo.ordem} onChange={e => setEditandoGrupo(p => ({ ...p, ordem:e.target.value }))} placeholder="0" style={_iS} />
                    </div>
                  </div>
                  <div style={{ display:"flex", gap:8, marginTop:14 }}>
                    <button onClick={() => setEditandoGrupo(null)} style={{ flex:1, padding:"10px 0", borderRadius:9, border:`1px solid ${C.border}`, background:"transparent", color:C.textSoft, fontWeight:700, fontSize:13, cursor:"pointer" }}>Cancelar</button>
                    <button onClick={salvarGrupo} style={{ flex:2, padding:"10px 0", borderRadius:9, border:"none", background:C.green, color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer" }}>💾 Salvar Grupo</button>
                  </div>
                </div>
              </div>
            )}

            {/* Modal: editor de item */}
            {editandoItem && (
              <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.5)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }} onClick={() => setEditandoItem(null)}>
                <div onClick={e => e.stopPropagation()} style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:14, padding:18, maxWidth:480, width:"100%", maxHeight:"90vh", overflow:"auto" }}>
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:14 }}>
                    <span style={{ fontSize:15, fontWeight:800, color:C.text }}>{editandoItem.item._existeId ? "Editar Item" : "Novo Item"}</span>
                    <button onClick={() => setEditandoItem(null)} style={{ background:"none", border:"none", fontSize:18, color:C.textMuted, cursor:"pointer" }}>✕</button>
                  </div>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
                    <div>
                      <label style={_lS}>Nome do Item *</label>
                      <input value={editandoItem.item.nome} onChange={e => setEditandoItem(p => ({ ...p, item:{ ...p.item, nome:e.target.value } }))} placeholder="Ex: Ao ponto" style={_iS} autoFocus />
                    </div>
                    <div>
                      <label style={_lS}>Preço (opcional)</label>
                      <input inputMode="numeric" value={editandoItem.item.preco} onChange={e => setEditandoItem(p => ({ ...p, item:{ ...p.item, preco:mascaraPreco(e.target.value.replace(/\D/g,"")) } }))} placeholder="Vazio = grátis" style={_iS} />
                    </div>
                  </div>
                  <div style={{ marginBottom:10 }}>
                    <label style={_lS}>Ordem</label>
                    <input type="number" value={editandoItem.item.ordem} onChange={e => setEditandoItem(p => ({ ...p, item:{ ...p.item, ordem:e.target.value } }))} placeholder="0" style={_iS} />
                  </div>
                  <div style={{ marginBottom:10 }}>
                    <label style={_lS}>Foto (opcional)</label>
                    <label style={{ display:"flex", alignItems:"center", gap:8, padding:"9px 14px", background:C.bg, border:`1px dashed ${C.border}`, borderRadius:9, cursor:"pointer", fontSize:12, color:C.text, justifyContent:"center" }}>
                      <span>📸</span><span>{editandoItem.item.imagem_url ? "Trocar foto" : "Selecionar foto"}</span>
                      <input type="file" accept="image/*" style={{ display:"none" }} onChange={e => { if (e.target.files[0]) { uploadArquivo(e.target.files[0], "adicional").then(r => { if (r.url) setEditandoItem(p => ({ ...p, item:{ ...p.item, imagem_url: r.url } })); }); } e.target.value=""; }} />
                    </label>
                    {editandoItem.item.imagem_url && <div style={{ marginTop:6, display:"flex", alignItems:"center", gap:8 }}><img src={editandoItem.item.imagem_url} alt="" style={{ width:40, height:40, borderRadius:7, objectFit:"cover" }} /><span style={{ fontSize:11, color:C.greenLight, fontWeight:600 }}>✓ Selecionada</span><button onClick={() => setEditandoItem(p => ({ ...p, item:{ ...p.item, imagem_url:"" } }))} style={{ background:"none", border:"none", color:"#E8201A", cursor:"pointer", fontSize:12 }}>✕</button></div>}
                  </div>
                  <div style={{ display:"flex", gap:8, marginTop:14 }}>
                    <button onClick={() => setEditandoItem(null)} style={{ flex:1, padding:"10px 0", borderRadius:9, border:`1px solid ${C.border}`, background:"transparent", color:C.textSoft, fontWeight:700, fontSize:13, cursor:"pointer" }}>Cancelar</button>
                    <button onClick={salvarItem} style={{ flex:2, padding:"10px 0", borderRadius:9, border:"none", background:C.green, color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer" }}>💾 Salvar Item</button>
                  </div>
                </div>
              </div>
            )}

            <button disabled={salvando} onClick={submitProduto} style={editProd ? bEditS : bS}>
              {salvando ? "Salvando..." : (editProd ? "Salvar Produto" : "Cadastrar Produto")}
            </button>
          </>}

          {/* CAIXINHA */}
          {sub === "caixinha" && <>
            <Field label="Nome *" ph="Ex: Caixinha do Chef" value={fCaixa.nome} onChange={v => setFCaixa(p => ({ ...p, nome:v }))} />
            <Field label="Descrição" ph="Descrição da caixinha" value={fCaixa.descricao} onChange={v => setFCaixa(p => ({ ...p, descricao:v }))} />
            <Field label="Preço Promocional (R$) *" ph="0,00" money value={fCaixa.preco} onChange={v => setFCaixa(p => ({ ...p, preco:v }))} />
            <Field label="Preço Original (R$)" ph="0,00" money value={fCaixa.preco_original} onChange={v => setFCaixa(p => ({ ...p, preco_original:v }))} />
            <Field label="Limite de Unidades" ph="50" type="number" value={fCaixa.quantidade_limite} onChange={v => setFCaixa(p => ({ ...p, quantidade_limite:v }))} />
            <SelectField label="Ativo" value={fCaixa.ativo} onChange={v => setFCaixa(p => ({ ...p, ativo:v }))} options={[{ v:"1", l:"Sim" }, { v:"0", l:"Não" }]} />
            <div style={{ marginBottom:14 }}>
              <label style={lS}>Foto da Caixinha</label>
              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                <label style={{ display:"flex", alignItems:"center", gap:8, padding:"10px 16px", background:C.bg, border:`1px dashed ${uploadingCaixa ? "#22C55E" : C.border}`, borderRadius:10, cursor:"pointer", color:C.text, fontSize:13, flex:1, justifyContent:"center" }}>
                  {uploadingCaixa ? <><div style={{ width:13, height:13, border:"2px solid #22C55E", borderTopColor:"transparent", borderRadius:"50%", animation:"spin 1s linear infinite" }} /><span style={{ color:"#22C55E", fontWeight:600 }}>Enviando...</span></> : <><span>📸</span><span>{fCaixa.imagem_url ? "Trocar foto" : "Selecionar foto"}</span></>}
                  <input type="file" accept="image/*" style={{ display:"none" }} disabled={uploadingCaixa} onChange={e => { if (e.target.files[0]) handleUploadCaixa(e.target.files[0]); e.target.value=""; }} />
                </label>
                {fCaixa.imagem_url && <button onClick={() => setFCaixa(p => ({ ...p, imagem_url:"" }))} style={{ padding:"10px 14px", background:"#E8201A18", border:"1px solid #E8201A30", borderRadius:10, color:"#E8201A", cursor:"pointer", fontSize:13, fontWeight:600 }}>✕</button>}
              </div>
              {fCaixa.imagem_url && (
                <div style={{ marginTop:8, display:"flex", alignItems:"center", gap:8 }}>
                  <img src={fCaixa.imagem_url} alt="" style={{ width:48, height:48, borderRadius:8, objectFit:"cover", border:`1px solid ${C.border}` }} />
                  <span style={{ fontSize:11, color:"#22C55E", fontWeight:600 }}>✓ Imagem selecionada</span>
                </div>
              )}
            </div>
            <button disabled={salvando} onClick={() => submitForm("caixinha_surpresa", fCaixa, "Caixinha", () => { setFCaixa({ nome:"", descricao:"", preco:"", preco_original:"", quantidade_limite:"", ativo:"1", imagem_url:"" }); setEditCaixa(null); }, editCaixa)} style={editCaixa ? bEditS : bS}>
              {salvando ? "Salvando..." : (editCaixa ? "Salvar Caixinha" : "Cadastrar Caixinha")}
            </button>
          </>}
        </Card>

        {/* ── LISTA ── */}
        <Card>
          <h3 style={{ fontSize:18, fontWeight:700, marginBottom:20 }}>{titles[sub]} Cadastrados</h3>

          {sub === "categorias" && (categorias.length === 0 ? <EmptyState text="Nenhuma categoria" /> :
            categorias.map(c => listCard(
              <>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontWeight:700 }}>{c.nome}</span>
                  <span style={{ fontSize:11, fontWeight:700, color:C.greenLight, background:`${C.greenLight}15`, padding:"3px 10px", borderRadius:6 }}>Ativo</span>
                </div>
                <div style={{ fontSize:12, color:C.textMuted, marginTop:4 }}>{c.descricao || "—"} · Ordem: {c.ordem||0} · ID: {c.id}</div>
                <AcoesBotoes C={C}
                  onEditar={() => { setEditCat(c.id); setFCat({ nome:c.nome, descricao:c.descricao||"", ordem:String(c.ordem||0) }); window.scrollTo({ top:0, behavior:"smooth" }); }}
                  onExcluir={() => excluir("categorias_loja", c.id, "Categoria")}
                />
              </>
            ))
          )}

          {sub === "subcategorias" && (subcategorias.length === 0 ? <EmptyState text="Nenhuma sub categoria" /> :
            subcategorias.map(s => listCard(
              <>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontWeight:700 }}>{s.nome}</span>
                  <span style={{ fontSize:11, fontWeight:700, color:C.greenLight, background:`${C.greenLight}15`, padding:"3px 10px", borderRadius:6 }}>Ativo</span>
                </div>
                <div style={{ fontSize:12, color:C.textMuted, marginTop:4 }}>Categoria: {categorias.find(c => String(c.id) === String(s.categoria_id))?.nome || "#"+s.categoria_id} · ID: {s.id}</div>
                <AcoesBotoes C={C}
                  onEditar={() => { setEditSub(s.id); setFSub({ nome:s.nome, categoria_id:String(s.categoria_id), descricao:s.descricao||"" }); window.scrollTo({ top:0, behavior:"smooth" }); }}
                  onExcluir={() => excluir("subcategorias", s.id, "Sub Categoria")}
                />
              </>
            ))
          )}

          {sub === "produtos" && (produtos.length === 0 ? <EmptyState text="Nenhum produto" /> :
            <div style={{ maxHeight:600, overflowY:"auto" }}>
              {produtos.map(p => listCard(
                <>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:10 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                      {p.imagem_url && <img src={p.imagem_url} alt="" style={{ width:44, height:44, borderRadius:9, objectFit:"cover", border:`1px solid ${C.border}`, flexShrink:0 }} />}
                      <span style={{ fontWeight:700 }}>{p.nome}</span>
                    </div>
                    <span style={{ fontSize:13, fontWeight:800, color:C.greenLight, flexShrink:0 }}>R$ {parseFloat(p.preco||0).toFixed(2).replace(".",",")}</span>
                  </div>
                  <div style={{ fontSize:12, color:C.textMuted, marginTop:4 }}>
                    {categorias.find(c => String(c.id) === String(p.categoria_id))?.nome || "—"} · {p.descricao || "—"} · ID: {p.id}
                  </div>
                  <div style={{ marginTop:6, display:"flex", alignItems:"center", justifyContent:"space-between", gap:8 }}>
                    <span style={{ fontSize:11, fontWeight:700, color: (p.disponivel!==false && p.disponivel!==0 && p.disponivel!=="0") ? C.greenLight : "#E8201A", background: (p.disponivel!==false && p.disponivel!==0 && p.disponivel!=="0") ? `${C.greenLight}15` : "#E8201A15", padding:"2px 8px", borderRadius:6 }}>
                      {(p.disponivel!==false && p.disponivel!==0 && p.disponivel!=="0") ? "Disponível" : "Indisponível"}
                    </span>
                    <button onClick={async () => {
                      const novoEst = (p.disponivel!==false && p.disponivel!==0 && p.disponivel!=="0") ? 0 : 1;
                      try {
                        const r = await put("produtos", p.id, { disponivel: novoEst });
                        if (r.error) notify(r.error, false);
                        else { notify(novoEst ? "Produto disponível" : "Produto pausado"); fetchData(); }
                      } catch (e) { notify("Erro: " + e.message, false); }
                    }} style={{ padding:"4px 12px", borderRadius:6, border:"none", background: (p.disponivel!==false && p.disponivel!==0 && p.disponivel!=="0") ? "#F59E0B" : "#22C55E", color:"#fff", fontSize:11, fontWeight:700, cursor:"pointer" }}>
                      {(p.disponivel!==false && p.disponivel!==0 && p.disponivel!=="0") ? "⏸ Pausar" : "▶ Ativar"}
                    </button>
                  </div>
                  <AcoesBotoes C={C}
                    onEditar={() => { setEditProd(p.id); setFProd({ nome:p.nome, descricao:p.descricao||"", preco:mascaraPreco(Math.round(parseFloat(p.preco||0)*100)), preco_promocional:p.preco_promocional ? mascaraPreco(Math.round(parseFloat(p.preco_promocional)*100)) : "", categoria_id:String(p.categoria_id||""), subcategoria_id:String(p.subcategoria_id||""), disponivel:String(p.disponivel||"1"), destaque:String(p.destaque||"0"), ordem:String(p.ordem||"0"), tempo_preparo:String(p.tempo_preparo||"15"), cashback_pct:String(p.cashback_pct||"0"), imagem_url:p.imagem_url||"" }); setGruposExcluir([]); setItensExcluir([]); setEditandoGrupo(null); setEditandoItem(null); carregarGruposDoProduto(p.id); window.scrollTo({ top:0, behavior:"smooth" }); }}
                    onCopiar={() => copiarProd(p)}
                    onExcluir={() => excluir("produtos", p.id, "Produto")}
                  />
                </>
              ))}
            </div>
          )}

          {sub === "adicionais" && <EmptyState text="Adicionais agora são cadastrados dentro de cada produto" />}

          {sub === "caixinha" && (caixinhas.length === 0 ? <EmptyState text="Nenhuma caixinha" /> :
            caixinhas.map(c => listCard(
              <>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontWeight:700 }}>{c.nome}</span>
                  <span style={{ fontSize:13, fontWeight:800, color:C.greenLight }}>R$ {parseFloat(c.preco||0).toFixed(2).replace(".",",")}</span>
                </div>
                <div style={{ fontSize:12, color:C.textMuted, marginTop:4 }}>Original: R$ {parseFloat(c.preco_original||0).toFixed(2).replace(".",",")} · Limite: {c.quantidade_limite||"∞"} · ID: {c.id}</div>
                <AcoesBotoes C={C}
                  onEditar={() => { setEditCaixa(c.id); setFCaixa({ nome:c.nome, descricao:c.descricao||"", preco:mascaraPreco(Math.round(parseFloat(c.preco||0)*100)), preco_original:mascaraPreco(Math.round(parseFloat(c.preco_original||0)*100)), quantidade_limite:String(c.quantidade_limite||""), ativo:String(c.ativo||"1"), imagem_url:c.imagem_url||"" }); window.scrollTo({ top:0, behavior:"smooth" }); }}
                  onCopiar={() => copiarCaixa(c)}
                  onExcluir={() => excluir("caixinha_surpresa", c.id, "Caixinha")}
                />
              </>
            ))
          )}
        </Card>
      </div>

      {/* MODAL: Reajuste em Massa */}
      <ReajusteMassa
        aberto={showReajuste}
        lojaId={lojaId}
        produtos={produtos}
        categorias={categorias}
        subcategorias={subcategorias}
        onFechar={() => setShowReajuste(false)}
        onSucesso={() => { fetchData(); }}
      />
    </div>
  );
}
/* ══════════════════════════════════════════════════════════════════════════
 * COMPONENTE: CATÁLOGO WEB
 * Mostra preview da URL pública + lista editável de produtos lado a lado
 * ══════════════════════════════════════════════════════════════════════════ */
function CatalogoWeb({ lojaId, C }) {
  const [loja, setLoja] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editandoSlug, setEditandoSlug] = useState(false);
  const [novoSlug, setNovoSlug] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [toast, setToast] = useState(null);
  const [iframeKey, setIframeKey] = useState(0);

  const notify = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 2500); };

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const r = await get("lojas", { id: lojaId });
      const l = (r.dados && r.dados[0]) || null;
      setLoja(l);
      setNovoSlug(l?.slug || "");
    } catch (e) {}
    setLoading(false);
  }, [lojaId]);

  useEffect(() => { carregar(); }, [carregar]);

  const slug = loja?.slug || "";
  const urlPublica = slug ? `https://mixupbr.com.br/rapiditos/${slug}` : "";

  const salvarSlug = async () => {
    const s = (novoSlug || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    if (!s) { notify("Slug inválido", false); return; }
    setSalvando(true);
    try {
      const r = await put("lojas", lojaId, { slug: s });
      if (r.error) {
        notify(r.error, false);
      } else {
        notify("Link atualizado!");
        setEditandoSlug(false);
        await carregar();
        setIframeKey(k => k + 1);
      }
    } catch (e) {
      notify("Erro: " + e.message, false);
    }
    setSalvando(false);
  };

  const copiarLink = () => {
    if (!urlPublica) return;
    navigator.clipboard.writeText(urlPublica).then(() => notify("Link copiado!"));
  };

  const compartilharWA = () => {
    if (!urlPublica) return;
    const msg = encodeURIComponent(`Confira nosso catálogo online:\n${urlPublica}`);
    window.open(`https://wa.me/?text=${msg}`, "_blank");
  };

  const recarregarPreview = () => setIframeKey(k => k + 1);

  if (loading) return <div style={{ padding: 40, textAlign: "center", color: C.textMuted }}>Carregando...</div>;
  if (!loja) return <EmptyState text="Loja não encontrada" />;

  return (
    <div style={{ animation: "fadeUp .4s ease-out" }}>
      {toast && <div style={{ position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)", zIndex: 9999, background: toast.ok ? "#22C55E" : "#EF4444", color: "#fff", padding: "10px 24px", borderRadius: 10, fontWeight: 700, fontSize: 13 }}>{toast.msg}</div>}

      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 24 }}>
        <div style={{ width: 52, height: 52, borderRadius: 16, background: "#3B82F618", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26 }}>🌐</div>
        <div>
          <h1 style={{ fontFamily: "'Plus Jakarta Sans'", fontWeight: 800, fontSize: 28 }}>Catálogo Web</h1>
          <p style={{ fontSize: 13, color: C.textMuted, marginTop: 2 }}>URL pública para compartilhar nas redes sociais</p>
        </div>
      </div>

      {/* Bloco da URL */}
      <Card style={{ marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <span style={{ fontSize: 18 }}>🔗</span>
          <span style={{ fontSize: 14, fontWeight: 700 }}>Link público da loja</span>
        </div>

        {!editandoSlug ? (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "12px 14px", background: C.bg, borderRadius: 10, border: `1px solid ${C.border}`, marginBottom: 12 }}>
              <span style={{ flex: 1, fontFamily: "monospace", fontSize: 13, color: "#22C55E", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{urlPublica || "(sem link)"}</span>
              <button onClick={copiarLink} disabled={!urlPublica} style={{ padding: "6px 12px", background: "#3B82F6", color: "#fff", border: "none", borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>📋 Copiar</button>
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button onClick={() => window.open(urlPublica, "_blank")} disabled={!urlPublica} style={{ padding: "8px 14px", background: "#22C55E", color: "#fff", border: "none", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>↗ Abrir em nova aba</button>
              <button onClick={compartilharWA} disabled={!urlPublica} style={{ padding: "8px 14px", background: "#25D366", color: "#fff", border: "none", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>💬 Compartilhar WhatsApp</button>
              <button onClick={() => setEditandoSlug(true)} style={{ padding: "8px 14px", background: "transparent", color: C.text, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>✏ Editar URL</button>
              <button onClick={recarregarPreview} style={{ padding: "8px 14px", background: "transparent", color: C.text, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>🔄 Recarregar preview</button>
            </div>
          </>
        ) : (
          <div>
            <div style={{ fontSize: 11, color: C.textMuted, marginBottom: 6 }}>Use só letras minúsculas, números e hifens</div>
            <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "10px 14px", background: C.bg, borderRadius: 10, border: `1px solid ${C.border}`, marginBottom: 12 }}>
              <span style={{ fontFamily: "monospace", fontSize: 12, color: C.textMuted }}>mixupbr.com.br/rapiditos/</span>
              <input value={novoSlug} onChange={e => setNovoSlug(e.target.value)} autoFocus style={{ flex: 1, background: "transparent", border: "none", outline: "none", color: "#22C55E", fontFamily: "monospace", fontSize: 13, fontWeight: 700 }} />
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={salvarSlug} disabled={salvando} style={{ padding: "8px 16px", background: "#22C55E", color: "#fff", border: "none", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>{salvando ? "Salvando..." : "Salvar"}</button>
              <button onClick={() => { setEditandoSlug(false); setNovoSlug(loja.slug || ""); }} style={{ padding: "8px 16px", background: "transparent", color: C.text, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Cancelar</button>
            </div>
          </div>
        )}
      </Card>

      {/* Preview do iframe */}
      <Card>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <span style={{ fontSize: 18 }}>📱</span>
          <span style={{ fontSize: 14, fontWeight: 700 }}>Preview ao vivo</span>
          <span style={{ fontSize: 11, color: C.textMuted, marginLeft: "auto" }}>É exatamente como o cliente vê</span>
        </div>
        {urlPublica ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 16, background: C.bg, borderRadius: 12, border: `1px solid ${C.border}` }}>
            <div style={{ width: 380, height: 700, borderRadius: 28, overflow: "hidden", border: `8px solid #1F2937`, boxShadow: "0 10px 40px rgba(0,0,0,.4)" }}>
              <iframe key={iframeKey} src={urlPublica} title="Preview" style={{ width: "100%", height: "100%", border: "none" }} />
            </div>
          </div>
        ) : (
          <EmptyState text="Configure o slug primeiro" />
        )}
      </Card>
    </div>
  );
}
